import React, { Component } from "react";
import "./RelateOrganizations.css";
import { RelateOrganizationsItem } from "./RelateOrganizationsItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { RelateOrganizationsData } from "../../Data/Data";

class RelateOrganizations extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();
    this.category = "";

    this.RelateOrganizationsSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      arrows: false,
      slidesToShow: this.props.items != undefined ? this.props.items : 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };
  }

  render() {
    const data = [...RelateOrganizationsData];
    const postsHtml = data.map((o, i) => {
      console.log("o.category: ", o.category);
      console.log("this.props.category: ", this.props.category);
      if (this.props.category == o.category) {
        return (
          <RelateOrganizationsItem name={o.name} href={o.href} id={i} key={i} />
        );
      }
      //console.log('o:', o);
    });
    return (
      <div className={`wrapper-relateorganizations ${this.props.category}`}>
        {/*<SimpleSlider settings={this.WebinarsSliderSettings}>{postsHtml}</SimpleSlider>*/}

        {postsHtml}
      </div>
    );
  }
}

export default RelateOrganizations;



// WEBPACK FOOTER //
// ./src/Components/RelateOrganizations/RelateOrganizations.js